/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { CmsImage } from '../../CmsImage/CmsImage';
import type { ProductGridCardPreviewItem } from '../types';

type ProductGridCardPreviewProps = {
  previewImageAlt: string;
  visiblePreviewItems: ProductGridCardPreviewItem[];
  hiddenPreviewCount: number;
  isPreviewCard: boolean;
};

export const ProductGridCardPreview = ({
  previewImageAlt,
  visiblePreviewItems,
  hiddenPreviewCount,
  isPreviewCard,
}: ProductGridCardPreviewProps) => (
  <div
    className={classNames(
      'relative flex items-center',
      isPreviewCard
        ? 'gap-1.5 md:gap-spacing/gap/soft-8px'
        : 'gap-0.5 md:gap-spacing/gap/soft-4px',
    )}
  >
    {visiblePreviewItems.map((previewItem, index) => (
      <div
        key={`${previewItem.imageUrl ?? 'no-image'}-${previewItem.title ?? index}`}
        title={previewItem.title}
        className="h-7 w-6 shrink-0 md:size-10"
      >
        <div
          className={classNames(
            'overflow-hidden border border-borders/default',
            'flex h-7 w-6 items-center justify-center rounded-[6px] bg-gradient-to-b from-fill/card to-fill/alternative-1 p-[6px] md:size-10 md:rounded-radius/button md:p-spacing/padding/soft-8px',
          )}
        >
          {previewItem.imageUrl ? (
            <CmsImage
              src={previewItem.imageUrl}
              alt={previewImageAlt}
              width={40}
              height={40}
              sizes={{ _: 24, md: 40 }}
              className={classNames('size-full', 'object-contain')}
            />
          ) : (
            <div className="flex size-full items-center justify-center bg-fill/card px-1 text-center text-[8px] leading-[1.1] text-text/secondary-lighter md:text-[9px]">
              {previewItem.title ?? previewImageAlt}
            </div>
          )}
        </div>
      </div>
    ))}
    {hiddenPreviewCount > 0 && (
      <div
        className={classNames(
          'flex items-center justify-center rounded-[4px] border border-borders/default bg-fill/card px-[6px] text-text/secondary-lighter mhg-alpha-bullet-2 md:mhg-alpha-body-2',
          isPreviewCard
            ? 'h-7 w-11 md:h-[50px] md:w-[78px]'
            : 'h-7 min-w-7 flex-1 md:h-10 md:min-w-10 md:px-spacing/padding/soft-8px',
        )}
      >
        +{hiddenPreviewCount}
      </div>
    )}
  </div>
);
